import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, ButtonGroup } from "react-bootstrap";
import Select from "react-select";
import Axios from "axios";
import { urlAPI } from "Common";
import Center from "react-center";
import moment from "moment";
import * as Icons from "react-feather";

const initSearchState = {
  type: "norm",
  nomor: "",
  kodekel: "",
  jaminan: "",
  noasuransi: "",
  noktp: "",
};
export default function Step6Page(props) {
  const {
    dataStep4,
    setDataStep4,
    dataStep3,
    setDataStep3,
    initStep3,
    setMessageState,
    setShowFailed,
    handlePrev,
    handleNext,
  } = props;
  const [searchState, setSearchState] = useState(initSearchState);
  const [pasienState, setPasienState] = useState("");
  const [typeSelector] = useState([
    { value: "norm", label: "Nomor Rekam Medik (NORM)" },
    { value: "noktp", label: "Nomor Induk Kependudukan (NIK/NO.KTP)" },
    { value: "nik", label: "Nomor Induk Karyawan (NIK)" },
    { value: "nobpjs", label: "Nomor BPJS" },
  ]);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [selectorKodeKel] = useState([
    { value: "", label: "Karyawan" },
    { value: "20", label: "Suami / Istri" },
    { value: "21", label: "Anak Pertama" },
    { value: "22", label: "Anak Kedua" },
    { value: "23", label: "Anak Ketiga" },
    { value: "24", label: "Anak Keempat" },
    { value: "25", label: "Anak Kelima" },
    { value: "26", label: "Anak Keenam" },
    { value: "27", label: "Anak Ketujuh" },
    { value: "28", label: "Anak Kedelapan" },
    { value: "29", label: "Anak Kesembilan" },
  ]);
  const [selectorJaminan] = useState([
    { value: "umum", label: "Pasien Umum" },
    { value: "bpjs", label: "BPJS" },
    { value: "prokespen", label: "Prokespen" },
    { value: "lain", label: "Asuransi Lain" },
  ]);
  const [selectorKelamin] = useState([
    { value: "L", label: "Laki-Laki" },
    { value: "P", label: "Perempuan" },
  ]);

  const fetchDataPasien = () => {
    Axios.get(
      urlAPI +
      "/public/pasien/data?params=" +
      JSON.stringify({
        type: searchState?.type,
        nomor: searchState?.nomor,
        kodekel: searchState?.kodekel,
      })
    )
      .then((response) => {
        if (response?.data?.result?.rows?.length === 1) {
          setPasienState(response?.data?.result?.rows[0]);
          setDataStep3({
            ...dataStep3,
            norm: response?.data?.result?.rows[0]?.NORM,
            nama: response?.data?.result?.rows[0]?.NAMA,
            tgllahir: response?.data?.result?.rows[0]?.TGLLAHIR,
            namacust: response?.data?.result?.rows[0]?.NAMACUST,
          });
          setLoadingSearch(false);
        } else {
          setPasienState(null);
          setDataStep3({ ...initStep3, jaminan: dataStep3?.jaminan });
          setLoadingSearch(false);
        }
      })
      .catch((err) => {
        setMessageState(err?.response?.pasienState?.message ?? err?.response);
        setShowFailed(true);
        setLoadingSearch(false);
      });
  };
  /*eslint-disable */
  useEffect(() => {
    if (searchState?.nomor.trim() !== "") {
      setLoadingSearch(true);
      fetchDataPasien();
    }
  }, []);
  /*eslint-enable */

  // console.log("searchState?.noktp", searchState?.noktp);

  return (
    <>
      <Card.Title>
        <strong>(2/4) Data Pasien Baru</strong>
      </Card.Title>
      <br />

      <Row>
        <Col lg="6" md="6" sm="12">
          <Form.Group className="mb-3">
            <Form.Label>Pilih Jaminan</Form.Label>
            <Select
              styles={{
                color: "black",
              }}
              id="jaminan"
              name="jaminan"
              isDisabled={loadingSearch}
              options={selectorJaminan}
              value={selectorJaminan.find(
                (find) => find?.value === searchState?.jaminan
              )}
              onChange={(e) => {
                setSearchState({
                  ...searchState,
                  jaminan: e.value,
                });
              }}
            />
          </Form.Group>
        </Col>

        {searchState?.jaminan === "prokespen" || searchState?.jaminan === "bpjs" ? (
          <>
            <Col lg="6" md="6" sm="12">
              <Form.Group className="mb-3">
                {searchState?.jaminan === "prokespen" ? (
                  <Form.Label>Nomor Asuransi</Form.Label>
                ) : (
                  <Form.Label>Nomor BPJS</Form.Label>
                )}
                <Form.Control
                  type="text"
                  id="noasuransi"
                  name="noasuransi"
                  disabled={loadingSearch}
                  value={searchState?.noasuransi}
                  onChange={(e) =>
                    setSearchState({
                      ...searchState,
                      noasuransi: e.target.value,
                    })
                  }
                />
              </Form.Group>
            </Col>
          </>
        ) : (
          <Col lg="5" md="6" sm="12"></Col>
        )}
      </Row>

      {loadingSearch ? (
        <>
          <br />
          <Center>
            <h3>Loading...</h3>
          </Center>
        </>
      ) : (
        <>
          <>
            <br />

            <Row>
              <Col lg="6" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>No. KTP</Form.Label>
                  <Form.Control
                    name="noktp"
                    id="noktp"
                    type="number"
                    value={setSearchState?.noktp}
                    disabled={false}
                    onChange={(e) =>
                      setSearchState({
                        ...searchState,
                        noktp: e.target.value,
                      })
                    }
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>TGL LAHIR</Form.Label>
                  <Form.Control
                    name="tgllahir"
                    id="tgllahir"
                    type="date"
                    value={setSearchState?.tgllahir}
                    disabled={false}
                    onChange={(e) =>
                      setSearchState({
                        ...searchState,
                        tgllahir: e.target.value,
                      })
                    }
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>ALAMAT</Form.Label>
                  <Form.Control
                    name="alamat"
                    id="alamat"
                    type="text"
                    value={setSearchState?.alamat}
                    disabled={false}
                    onChange={(e) =>
                      setSearchState({
                        ...searchState,
                        alamat: e.target.value.toUpperCase(),
                      })
                    }
                  />
                </Form.Group>

                {/* <Form.Group className="mb-3">
                    <Form.Label>TEMPAT LAHIR</Form.Label>
                    <Form.Control
                      name="TEMPATLAHIR"
                      id="TEMPATLAHIR"
                      type="text"
                      value={pasienState?.TEMPATLAHIR}
                      disabled={false}
                    />
                  </Form.Group>                   */}
              </Col>
              <Col lg="6" md="6" sm="12">
                <Form.Group className="mb-3">
                  <Form.Label>NAMA</Form.Label>
                  <Form.Control
                    name="nama"
                    id="nama"
                    type="text"
                    value={pasienState?.nama}
                    disabled={false}
                    onChange={(e) =>
                      setSearchState({
                        ...searchState,
                        nama: e.target.value.toUpperCase(),
                      })
                    }
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>JENIS KELAMIN</Form.Label>
                  <Select
                    styles={{
                      color: "black",
                    }}
                    id="kelamin"
                    name="kelamin"
                    isDisabled={loadingSearch}
                    options={selectorKelamin}
                    value={selectorKelamin.find(
                      (find) => find?.value === searchState?.kelamin
                    )}
                    onChange={(e) => {
                      setSearchState({
                        ...searchState,
                        kelamin: e.value,
                      });
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>NO TELP</Form.Label>
                  <Form.Control
                    name="notelp"
                    id="notelp"
                    type="number"
                    value={setSearchState?.notelp}
                    disabled={false}
                    onChange={(e) =>
                      setSearchState({
                        ...searchState,
                        notelp: e.target.value,
                      })
                    }
                  />
                </Form.Group>

                {/* <Form.Group className="mb-3">
                    <Form.Label>AGAMA</Form.Label>
                    <Form.Control
                      name="AGAMA"
                      id="AGAMA"
                      type="text"
                      value={pasienState?.AGAMA}
                      disabled={false}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>STATUS PERKAWINAN</Form.Label>
                    <Form.Control
                      name="STATUSKAWIN"
                      id="STATUSKAWIN"
                      type="text"
                      value={pasienState?.STATUSKAWIN}
                      disabled={false}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>PEKERJAAN</Form.Label>
                    <Form.Control
                      name="PEKERJAAN"
                      id="PEKERJAAN"
                      type="text"
                      value={pasienState?.PEKERJAAN}
                      disabled={false}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>KWARGANEGARAAN</Form.Label>
                    <Form.Control
                      name="KWARGANEGARAAN"
                      id="KWARGANEGARAAN"
                      type="text"
                      value={pasienState?.KWARGANEGARAAN}
                      disabled={false}
                    />
                  </Form.Group> */}
              </Col>
            </Row>
            <br />
          </>

          <Row>
            <Col lg="6" md="6" className="d-none d-md-block">
              <Button
                style={{ float: "left" }}
                variant="secondary"
                disabled={loadingSearch}
                onClick={() => {
                  handlePrev();
                }}
              >
                <Icons.ArrowLeft size={18} />
                Kembali
              </Button>
            </Col>

            <Col lg="6" md="6" className="d-none d-md-block">
              <Button
                style={{ float: "right" }}
                variant="primary"
                disabled={searchState?.jaminan === ""}
                onClick={() => {
                  setDataStep3({
                    ...dataStep3,
                    noasuransi: searchState?.noasuransi,
                    jaminan: searchState?.jaminan,
                    noktp: searchState?.noktp,
                    nama: searchState?.nama,
                    tgllahir: searchState?.tgllahir,
                    kelamin: searchState?.kelamin,
                    alamat: searchState?.alamat,
                  });
                  setDataStep4({ ...dataStep4, tlp: searchState?.notelp });
                  handleNext();
                }}
              >
                Simpan & Lanjutkan <Icons.ArrowRight size={18} />
              </Button>
            </Col>
            <Col className="d-block d-md-none" sm="12">
              <ButtonGroup style={{ width: "100%" }}>
                <Button
                  variant="secondary"
                  disabled={loadingSearch}
                  onClick={() => {
                    handlePrev();
                  }}
                >
                  <Icons.ArrowLeft size={18} />
                  Kembali
                </Button>
                &nbsp;
                <Button
                  variant="primary"
                  disabled={searchState?.jaminan === ""}
                  onClick={() => {
                    setDataStep3({
                      ...dataStep3,
                      noasuransi: searchState?.noasuransi,
                      jaminan: searchState?.jaminan,
                      noktp: searchState?.noktp,
                      nama: searchState?.nama,
                      tgllahir: searchState?.tgllahir,
                      kelamin: searchState?.kelamin,
                      alamat: searchState?.alamat,
                    });
                    setDataStep4({ ...dataStep4, tlp: searchState?.notelp });
                    handleNext();
                  }}
                >
                  Lanjutkan <Icons.ArrowRight size={18} />
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
        </>
      )}
    </>
  );
}
